import axios from 'axios';

/**
 * Simple async function to fetch a token for external systems
 * @returns {Promise<string>} The token string, empty string if error
 */
export const fetchToken = async () => {
  try {
    const response = await axios.post('https://data.mayfair-inc.com/aeolus/api/v3/openapi/jwtToken', {
      metadata: {
        clientId: '3bdc2e099666bf69e09268b89de860ee',
        clientSecret: '588122692b7dd1f226a2f4610216d8a0',
        expire: 86400, // 单位秒，最长3天
        proxyUser: 'admin',
      },
    }, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });
    
    const result = response.data;
    if (result?.data?.jwtToken) {
      // 有效期一天
      return `&jwtToken=${result.data.jwtToken}`;
    }
    return '';
  } catch (e) {
    console.log(e);
    return '';
  }
};
